import axios from 'axios';

class StatModel{
    static async fetchTheResultFromTheBackend(inputModel, accessToken) {
        let encodedInputModel = encodeURIComponent(JSON.stringify(inputModel));
        let reqInstance = axios.create({
            headers: {
              authorization : `Bearer ${accessToken}`,
            }
            
        });
        const results = await reqInstance.get(`/.netlify/functions/getResult?inputModel=${encodedInputModel}`);
        if (results.status !== 200) {
            alert("Error in calling the backend.");
            return null;
        }
        if (results.data.suceeded !== true) {
            if (results.data.authorized === false) {
                alert("The backend cannot authenticate you. Please refresh the page and login again. If the problem is consistent, please contact the administrator.");
            }
            else {
                alert("Error in calling the backend. message: " + results.data.message + ".");
            }
            return null;
        }
        let backendresult = results.data.result;
        let res = Object.setPrototypeOf(backendresult, StatModel.prototype);
        res = this.ConvertFromJsonType(res);
        return res;
    }

    static ConvertFromJsonType(jsonModel){ 
        let res = this.deepcopy(jsonModel);
        
        // add zeros for non-presenting point
        let [first,second] = this.AddZeroPoints(res.wordScore.values, res.wordScore.probabilities);
        res.wordScore.paddedValues = first;
        res.wordScore.chanceRange = [Math.round(res.wordScore.values[0]), Math.round(res.wordScore.values[res.wordScore.values.length - 1])];
        second = this.normalize(second);
        res.wordScore.normalizedPaddedProbabilities = second;
        
        // normalize the probabilities so that the pick is one for presentation
        res.Ssq.clarities.normalizedProbabilities = this.normalize(res.Ssq.clarities.probabilities);
        return res;
    }   
    static AddZeroPoints(values, probabilities) {
        let min = Math.min(...values);
        let max = Math.max(...values);
        let step = values[1] - values[0];
        let newValues = [];
        let newProbabilities = [];
        for (let i = (min-step); i >= 0; i -= step){
            newValues.push(i);
            newProbabilities.push(0);  
        }
        newValues = newValues.reverse();
        newProbabilities = newProbabilities.reverse();
        newValues = [...newValues, ...values];
        newProbabilities = [...newProbabilities, ...probabilities];
        for (let i = max + step; i <= 100; i += step){
            newValues.push(i);
            newProbabilities.push(0);
        }
        return [newValues, newProbabilities]; 
    }    
    static normalize(arr){
        if (Array.isArray(arr)) {
            let max = Math.max(...arr);
            let min = Math.min(...arr);
            let res = arr.map(item => (item - min) / (max - min));
            return res;
        } else if (typeof arr === 'object') {
            let keys = Object.keys(arr);
            let values = Object.values(arr);
            let max = Math.max(...values);
            let min = Math.min(...values);
            let res = {};
            for (let i = 0; i < keys.length; i++) {
                res[keys[i]] = (values[i] - min) / (max - min);
            }
            return res;
        } else {
            throw new Error('Invalid input type. Expected array or object.');
        }
    }
    
    static deepcopy(obg){
        return JSON.parse(JSON.stringify(obg));
    }       
}
export default StatModel;